import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { mePermissionIdsState, mePermissionsState,mePermissionState } from '../atom';
import type { Permission } from '../types';

export const useMePermissionsResponse = () => {
  const setMePermissions = useAtomCallback(
    useCallback((_get, set, data: Permission[]) => {
      set(mePermissionsState, []);
      set(mePermissionIdsState, []);
      data.forEach((d) => {
        set(mePermissionState(d.id), d);
      });
    }, [])
  );

  return {
    setMePermissions,
  };
};
